import {Component, Input, OnInit} from '@angular/core';
import {PostDO} from '../data-objects/PostDO';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-base-post',
  templateUrl: './base-post.component.html',
  styleUrls: ['./base-post.component.scss']
})
export class BasePostComponent implements OnInit {
  @Input() set post(value: PostDO) {
    this.postPrivate = value;
    if (value) {
      this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(value.content.rendered);
    }
  }

  get post(): PostDO {
    return this.postPrivate;
  }

  @Input() isLoading: boolean;
  @Input() hideFeaturedImage: boolean;
  sanitizedContent: SafeHtml;

  private postPrivate: PostDO;

  constructor(
    private sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {
  }

  get postImage(): string {
    return `url(${this.post.featuredImage})`;
  }

  get categories(): string[] {
    return this.hideFeaturedImage ? this.post.readableTagNames : this.post.parsedCategories;
  }
}
